import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Ola Clone App",
  titlePart2: "Development Company",
  description: "Leading experts in creating scalable, secure, and fully customizable taxi booking apps tailored for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "ola Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why is",
  titlePart2: "Ola Clone App",
  titlePart3: "Superlative For Taxi Booking Businesses?",
  description1: "In India’s bustling cities and expanding towns, where everyday mobility is a necessity, providing quick, reliable, and affordable transportation solutions is crucial to success. That’s where the OLA Clone app by Mobility Infotech emerges as a standout solution. Specially crafted for the Indian market, our robust clone app delivers a powerful ride-hailing platform that matches the industry benchmarks set by OLA. Whether you're a budding entrepreneur aiming to disrupt the local commute scene or a traditional fleet operator seeking to digitize and modernize, our OLA Clone app is your perfect launchpad. With features like real-time ride-matching, live driver tracking, automated fare estimations, in-app chat, and multiple secure payment integrations (including UPI and wallets like Paytm and PhonePe), this solution offers an intuitive experience for both passengers and drivers.",
  description2: "What makes our solution truly superlative isn’t just its sleek design or comprehensive features — it’s the strategic edge it provides your business. Our app comes with full white-labeling support, regional language options (including Hindi, Tamil, Telugu, Bengali, and more), geo-fencing for city-specific operations, surge pricing during high demand, promo codes, and referral systems. It is built to cater to diverse demographics and geographies across India. Scalability is at the heart of our architecture — whether you’re operating in one city or planning a pan-India rollout, the app scales as you grow. With smart backend controls and analytics, fleet management and customer support have never been easier. In India’s highly competitive mobility sector, technology is your biggest enabler. Choose Mobility Infotech’s OLA Clone app — the smarter, faster, and more scalable way to revolutionize your taxi business in India.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Powering India’s transportation evolution—one ride at a time.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch real-time taxi services with instant ride-matching, GPS-enabled driver tracking, and multiple payment options including UPI, Paytm, and PhonePe. Ideal for Indian startups or local taxi operators aiming to provide OLA-like convenience in metro cities and Tier-II towns.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Promote affordable and eco-conscious commuting with our intelligent ride-sharing app. Featuring route optimization, split fare calculation, and secure user authentication, this solution is perfect for Indian office-goers, college students, and smart city initiatives.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Simplify work-related travel with app-based solutions tailored for Indian businesses. Manage employee travel, track usage, generate GST-compliant invoices, and assign roles through a centralized admin dashboard — ideal for HR teams and enterprise mobility providers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Offer flexibility with hourly or outstation ride bookings. Perfect for tourists exploring Indian cities, business travelers attending multiple meetings, or customers needing chauffeur-driven rides without a fixed route.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Deliver a premium travel experience for India’s elite clientele with luxury car booking features, real-time chauffeur tracking, and personalized service options. Ideal for weddings, corporate events, VIP transfers, and luxury hospitality services.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Tap into India’s booming two-wheeler ride-hailing market. Enable quick, affordable bike rides ideal for solo commuters in traffic-dense urban areas. Supports last-mile connectivity for metro stations, offices, and residential neighborhoods.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Launch your own taxi app brand across Indian regions with our customizable white-label solution. Integrate your logo, color palette, local language support, and region-specific features for a distinctive market presence.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Simplify airport commutes with pre-scheduled rides, real-time flight tracking, and automated driver alerts. Tailored for fleet operators near major Indian airports like IGI (Delhi), Chhatrapati Shivaji (Mumbai), and Kempegowda (Bangalore).",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Drive sustainability in India’s mobility space with EV-enabled taxi solutions. Includes EV-specific ride options, nearest charging station integration, and government policy compliance — ideal for clean energy fleets and eco-conscious riders.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Ensure inclusive transportation for differently-abled users across India. Our app supports wheelchair-accessible vehicles, trained driver features, and SOS support — fully aligned with India's accessibility norms and user safety standards.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with India’s",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our next-gen taxi app solutions and steer your business toward unparalleled growth.",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Rise in Customer Loyalty and Repeat Rides",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Every Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch an OLA-like app? Understanding the operational flow is essential. Here's a streamlined look at how our OLA Clone App works to ensure seamless service and user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, we integrate the latest technologies into your OLA Clone taxi app to ensure outstanding user satisfaction, high operational efficiency, and scalable business growth. Here's what makes our solution truly cutting-edge:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "With AI algorithms tailored for Indian road networks, our system selects the shortest, traffic-free routes in real time. This saves fuel, reduces ride time, and boosts rider satisfaction, especially in traffic-prone areas like Mumbai, Delhi, and Bengaluru.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "IoT integration allows real-time monitoring of driver behavior, vehicle health, and trip routes. It helps fleet owners in Indian cities maintain vehicle uptime and ensures a safe travel experience for customers.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "Our multilingual AI chatbots provide round-the-clock support in English, Hindi, and regional languages — resolving queries, managing cancellations, and assisting bookings instantly to reduce call center loads.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Blockchain technology powers secure, transparent payment handling. Drivers and passengers benefit from fraud-resistant transactions, fair revenue settlements, and improved wallet trust — crucial in India’s digital-first ecosystem.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Our smart matching engine pairs riders with the most relevant nearby drivers based on proximity, user history, and driver performance. This reduces wait time and ensures higher service standards.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Augmented Reality tools offer improved navigation through visual cues and street overlays. This is especially useful for first-time users and drivers in high-density urban areas and unfamiliar neighborhoods.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of ",
  titlePart2: "Our OLA Clone Taxi App ",
  titlePart3: "Development",
  description: "Partner with Mobility Infotech to build a powerful, scalable, and future-ready OLA-like taxi app designed for the Indian market. From fast ride bookings to real-time tracking and seamless payments, our feature-rich app fuels your business growth at every level.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "A smooth, intuitive experience with every ride — your customers will enjoy smart convenience and real-time features built for Indian commuters.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Quick and easy ride requests with a user-friendly interface that caters to every Indian customer, whether they prefer Auto, Bike, Mini, or Prime options."
      },
      {
        title: "Flexible Payment Options",
        desc: "Accept UPI (PhonePe, GPay), credit/debit cards, Paytm wallets, and cash—secure and flexible options that work for everyone."
      },
      {
        title: "Live Trip Sharing",
        desc: "Passengers can share live trip details with friends or family members via WhatsApp/SMS for added safety and peace of mind."
      },
      {
        title: "Schedule a Ride",
        desc: "Let users pre-book rides for early morning trains, airport transfers, or important meetings—reliable scheduling on their terms."
      },
      {
        title: "Live Driver Tracking",
        desc: "Real-time GPS location tracking so customers can monitor the driver’s movement and ETA on the map with precision."
      },
      {
        title: "Push Notifications",
        desc: "Instant alerts for ride confirmations, driver arrival, offers, and more—delivered in-app and via SMS."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Empower your fleet with smart tools to manage bookings, maximize earnings, and ensure a hassle-free driving experience.",
    boxes: [
      {
        title: "Direct Calling",
        desc: "Drivers can call passengers straight from the app to confirm pickup locations or clarify instructions—no delays, no confusion."
      },
      {
        title: "Optimised Route Navigation",
        desc: "Integrated with Google Maps and real-time traffic updates for smooth and quick travel through busy Indian roads."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Drivers can begin and end trips with one tap and navigate precisely to pickup and drop-off points."
      },
      {
        title: "Built-In Help & Support",
        desc: "Instant access to app guides, route help, payment clarifications, and support resources from within the app."
      },
      {
        title: "Earnings Dashboard",
        desc: "A daily income tracker that breaks down ride earnings, commissions, and incentives—complete financial clarity for drivers."
      },
      {
        title: "In-App Chat",
        desc: "Secure chat system between drivers and riders to resolve queries instantly without needing third-party apps like WhatsApp."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "Manage every ride, driver, and vehicle in real time with a smart, centralised control system.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Systematically assigns rides to the nearest available drivers, reducing idle time and improving efficiency."
      },
      {
        title: "Booking Management",
        desc: "Accept, assign, and track ride bookings across zones, cities, and categories via a real-time dashboard."
      },
      {
        title: "Live Fleet Tracking",
        desc: "Monitor every active vehicle on the map—ideal for managing peak-hour traffic in metros like Delhi, Mumbai, and Bengaluru."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send direct messages or alerts to selected drivers or the entire fleet for urgent updates or rerouting."
      },
      {
        title: "Smart Route Planning",
        desc: "Suggest optimal trip paths to drivers to reduce fuel consumption and enhance passenger satisfaction."
      },
      {
        title: "Complete Transaction History",
        desc: "Detailed logs of every ride—completed, cancelled, or missed—along with fares, driver details, and timestamps."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Get full control over your OLA Clone app with advanced tools to manage operations, users, and growth strategies.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: "Onboard, verify, or deactivate drivers based on demand zones, feedback, and peak-time requirements."
      },
      {
        title: "In-Depth Analytics",
        desc: "Monitor bookings, customer trends, income flow, driver performance, and operational KPIs in one dashboard."
      },
      {
        title: "Integrated Payment Management",
        desc: "Handle UPI, card, and wallet transactions securely. View payment status, refunds, and earnings in real-time."
      },
      {
        title: "Promo & Loyalty Management",
        desc: "Launch offers, apply promo codes, and reward regular users with loyalty points—all from the backend dashboard."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Communicate instantly with dispatchers or drivers to resolve ride issues or handle customer complaints."
      },
      {
        title: "Booking Oversight",
        desc: "View, modify, or cancel rides, track user complaints, and ensure seamless ride management from one panel."
      },
    ]
  },
}

const customData = {
  titlePart1: "Serving Diverse Industries",
  titlePart2: "with Custom Taxi App Solutions",
  description: "Whether you're a taxi fleet operator, a travel service provider, or a large enterprise, the Ola Clone App by Mobility Infotech delivers scalable, secure, and highly customizable taxi booking solutions. Built for India’s evolving mobility landscape, our technology enhances customer experience, operational control, and business profitability.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Simplify event logistics with automated dispatch, guest ride tracking, and smooth route management for efficient, stress-free transport coordination.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Streamline school bus operations with real-time location updates, attendance logs, and timely alerts to parents and staff.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "Support seamless tour operations with driver tracking, route optimization, and easy customer communication tools for travel operators.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Optimize staff transport with secure ride management, trip logs, and shift-based dispatch for improved corporate travel planning.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Control your taxi business with tools for ride dispatch, fleet monitoring, and performance tracking — all in one place.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "A taxi app’s success isn’t just about getting people from point A to B—it’s about building a smart, sustainable revenue engine. With Mobility Infotech’s OLA Clone App solutions, you can unlock multiple income streams and boost ROI in the ever-growing Indian mobility market.",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Earn a fixed commission on every completed ride—your primary and most consistent income source.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Maximise earnings during high-demand hours (office rush, festive seasons, etc.) using dynamic pricing algorithms.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Premium Bookings",
      desc: "Offer luxury vehicles, sedans, and outstation cab options at higher rates—ideal for business travel.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Recover operational losses through fair and transparent cancellation fees applied when users cancel.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Enable drivers to either lease vehicles via the app or earn ride-based incentives—an accessible model in India.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Monetise your app’s traffic by offering banner or video ad slots to local and national brands.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over 5 years of industry expertise and the latest tech, Mobility Infotech helps you launch a fully customisable OLA Clone App tailored for Indian roads, users, and businesses.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Launch your branded taxi app with a full suite of custom features and integrations—no technical stress, just business focus.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Go live in under 3 days and start capturing ride bookings from day one.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Whether you're targeting one city or expanding pan-India, our infrastructure handles it all—smooth, fast, and stable.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Connect with top Indian payment systems like UPI, Paytm, Razorpay, and cash-on-delivery options.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Choose your ride types (Bike, Auto, Sedan), pricing logic, UI elements, and more—perfectly tailored to your business.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Designed for India’s diverse audience—from tech-savvy urban millennials to first-time app users in Tier 2 cities.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Features Powering",
  titlePart3: "Your Growth",
  description: "Why Indian businesses choose Mobility Infotech for their Ola Clone App:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch and driver allocation.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "Track drivers in real time via GPS.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations with smart dashboards.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Use analytics for data-driven decisions.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Accept Interac, Apple Pay, Google Pay, and more.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Build trust with ride ratings and feedback.",
    },
  ],
}

const globalData = {
  titlePart1: "Proven Business",
  titlePart2: " Impact from Our ",
  titlePart3: "Taxi App Clients",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is an OLA Clone App?",
    answer: "An OLA Clone App is a taxi booking solution designed to replicate the features and functionality of the popular OLA app. Mobility Infotech’s version is fully customizable for Indian cities, offering real-time ride booking, driver tracking, multiple payment options, and user-friendly interfaces for both riders and drivers.",
  },
  {
    id: "1",
    question: "02. Who can benefit from an OLA Clone App?",
    answer: "Entrepreneurs, taxi fleet operators, corporate transportation providers, luxury vehicle services, bike taxi operators, and startups can all leverage the OLA Clone App to digitize, scale, and streamline ride-hailing services in India.",
  },
  {
    id: "2",
    question: "03. How long does it take to launch the app?",
    answer: "With Mobility Infotech’s streamlined development process, your white-label OLA Clone App can be deployed and live in under 3 days, fully equipped with custom branding, regional languages, and payment integrations.",
  },
  {
    id: "3",
    question: "04. Is the app scalable across multiple cities in India?",
    answer: "Yes! The OLA Clone App is built with a scalable architecture that supports expansion from a single city to a pan-India rollout. Geo-fencing, city-specific operations, and surge pricing ensure smooth growth across regions.",
  },
  {
    id: "4",
    question: "05. What payment methods are supported?",
    answer: "The app integrates all major Indian payment systems, including UPI (GPay, PhonePe), Paytm, Razorpay, credit/debit cards, and cash options. Secure transactions are ensured with blockchain-enabled payment technology.",
  },
  {
    id: "5",
    question: "06. Can I customize the app according to my business needs?",
    answer: "Absolutely. Mobility Infotech offers full white-label customization: ride types (Bike, Auto, Sedan, SUV), UI themes, app logo and colors, pricing logic, and regional language support — all tailored for your target audience.",
  },
  {
    id: "6",
    question: "07. Does the app support corporate or enterprise usage?",
    answer: "Yes. Our corporate taxi booking solution allows employee travel management, GST-compliant invoices, role-based access, and centralized dashboards, making it ideal for Indian businesses managing employee transportation.",
  },
  {
    id: "7",
    question: "08. How does the app ensure rider and driver safety?",
    answer: "The app includes OTP-based verification, live GPS tracking, driver ratings, in-app chat, and SOS support for emergencies. It’s designed to meet safety standards and enhance trust for both drivers and passengers in India.",
  },
];

export default function OlaClone() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
